import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import ActionConfirmModal from '../../common/components/actionConfirmModal';
import PermissaoUsuario from '../../auth/permissao';
import {
  showUpdate,
  showMateriais,
  showInteracoes,
  remove,
  setPaginaAtual,
  iniciarOs,
  finalizarOs,
} from './ordemServicoActions';
import { formatSlaRestante, isSlaVencido, podeFinalizarOs, podeIniciarOs, temSlaAtivo } from './ordemServicoUtils';
import SPButton from '../../common/form/spButton';
import ReactTableGT2A from '../../common/grid/gridReactTable';
import PremiumTableShell from '../../common/grid/premiumTableShell';

const FILTRO_TODOS = '';

const STATUS_LABELS = {
  ABERTA: 'Aberta',
  AGUARDANDO_MATERIAL: 'Aguard. material',
  EM_ATENDIMENTO: 'Em atendimento',
  AGUARDANDO_VALIDACAO: 'Aguard. validação',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada',
};

const STATUS_BADGE_CLASS = {
  ABERTA: 'os-badge--blue',
  AGUARDANDO_MATERIAL: 'os-badge--amber',
  EM_ATENDIMENTO: 'os-badge--violet',
  AGUARDANDO_VALIDACAO: 'os-badge--teal',
  FINALIZADA: 'os-badge--green',
  CANCELADA: 'os-badge--gray',
};

const PRIORIDADE_BADGE_CLASS = {
  BAIXA: 'os-badge--gray',
  MEDIA: 'os-badge--blue',
  ALTA: 'os-badge--amber',
  CRITICA: 'os-badge--red',
};

const TIPO_LABELS = {
  CORRETIVA: 'Corretiva',
  PREVENTIVA: 'Preventiva',
  IMPLANTACAO: 'Implantação',
  RECLAMACAO: 'Reclamação',
};

const INTERACAO_TIPO_LABELS = {
  COMENTARIO: 'Comentário',
  ATUALIZACAO: 'Atualização',
  LAUDO: 'Laudo',
  CORRECAO: 'Correção',
};

function badge(text, modifierClass) {
  return <span className={`os-premium-badge ${modifierClass || 'os-badge--gray'}`}>{text}</span>;
}

function formatarHora(valor) {
  if (!valor) return '';
  const data = new Date(valor);
  return data.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function celulaTitulo(os) {
  const titulo = os.titulo;
  const grupo = os.grupo_fisico_descricao;
  const controlador =
    (os.controlador_numero !== null && os.controlador_numero !== undefined) && os.controlador_numero !== ''
      ? `Ctrl ${String(os.controlador_numero).padStart(2, '0')}`
      : null;
  const localTexto = [grupo, controlador].filter(Boolean).join(' · ');
  const temNotificacao = os.controlador_erro_id && os.mensagem_erro;
  const notificacaoTexto = temNotificacao ? String(os.mensagem_erro).trim() : '';

  if (!titulo && !localTexto && !notificacaoTexto) {
    return <span className="os-cell-muted">—</span>;
  }

  const tooltip = [titulo, localTexto, notificacaoTexto].filter(Boolean).join('\n');

  return (
    <div className="os-cell-titulo-stack" title={tooltip}>
      {titulo ? (
        <span className="os-cell-titulo-principal os-cell-ellipsis">{titulo}</span>
      ) : (
        <span className="os-cell-muted">—</span>
      )}
      {localTexto ? <span className="os-cell-titulo-meta os-cell-ellipsis">{localTexto}</span> : null}
      {notificacaoTexto ? (
        <span className="os-cell-titulo-notificacao os-cell-ellipsis">
          <i className="fa fa-bell" aria-hidden="true" /> {notificacaoTexto}
        </span>
      ) : null}
    </div>
  );
}

function celulaAtribuicao(row) {
  const equipe = row.original.equipe_nome;
  const responsavel = row.original.nome_usuario_responsavel;

  if (!equipe && !responsavel) {
    return <span className="os-cell-muted">—</span>;
  }

  return (
    <div className="os-cell-atribuicao-stack" title={[equipe, responsavel].filter(Boolean).join(' · ')}>
      {equipe ? (
        <span className="os-cell-ellipsis">
          {equipe} {responsavel ? '·' : ''} {responsavel}
        </span>
      ) : null}
    </div>
  );
}

function celulaInteracao(row) {
  const {
    ultima_interacao_texto: texto,
    ultima_interacao_tipo: tipo,
    ultima_interacao_data: data,
    ultima_interacao_usuario: usuario,
    ultima_interacao_qtd_anexos: qtdAnexos,
  } = row.original;

  if (!data) {
    return <span className="os-cell-muted">—</span>;
  }

  const temAnexos = Number(qtdAnexos) > 0;
  const temTexto = texto && texto !== '(sem texto)';
  const tooltip = [
    usuario,
    tipo ? INTERACAO_TIPO_LABELS[tipo] || tipo : null,
    temTexto ? texto : temAnexos ? 'Foto anexada' : null,
    temAnexos ? `${qtdAnexos} foto(s)` : null,
  ]
    .filter(Boolean)
    .join(' · ');

  return (
    <span className="os-cell-data os-cell-interacao-hora" title={tooltip}>
      {formatarHora(data)}
    </span>
  );
}

function filtrarPorLocal(ordens, filtroGrupoFisico, filtroControlador) {
  return ordens.filter(os => {
    if (filtroGrupoFisico && String(os.grupo_fisico_id || '') !== String(filtroGrupoFisico)) {
      return false;
    }
    if (filtroControlador && String(os.controlador_id || '') !== String(filtroControlador)) {
      return false;
    }
    return true;
  });
}

function filtrarOrdens(ordens, filtros) {
  const { filtroGrupoFisico, filtroControlador, filtroStatus, filtroNumero, filtroTitulo } = filtros;
  let resultado = filtrarPorLocal(ordens, filtroGrupoFisico, filtroControlador);

  if (filtroStatus) {
    resultado = resultado.filter(os => os.status === filtroStatus);
  }
  if (filtroNumero) {
    resultado = resultado.filter(os => os.numero === filtroNumero);
  }
  if (filtroTitulo && filtroTitulo.trim()) {
    const termo = filtroTitulo.trim().toLowerCase();
    resultado = resultado.filter(os => (os.titulo || '').toLowerCase().includes(termo));
  }

  return resultado;
}

function obterNumerosDisponiveis(ordens, filtroGrupoFisico, filtroControlador) {
  return filtrarPorLocal(ordens, filtroGrupoFisico, filtroControlador)
    .map(os => os.numero)
    .filter(Boolean)
    .filter((numero, index, lista) => lista.indexOf(numero) === index)
    .sort();
}

class OrdemServicoList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filtroGrupoFisico: FILTRO_TODOS,
      filtroControlador: FILTRO_TODOS,
      filtroStatus: FILTRO_TODOS,
      filtroNumero: FILTRO_TODOS,
      filtroTitulo: '',
      excluirOs: null,
    };
    this.removerOs = this.removerOs.bind(this);
    this.confirmarExclusaoOs = this.confirmarExclusaoOs.bind(this);
    this.cancelarExclusaoOs = this.cancelarExclusaoOs.bind(this);
    this.handleIniciarOs = this.handleIniciarOs.bind(this);
    this.handleFinalizarOs = this.handleFinalizarOs.bind(this);
    this.handleGrupoFisicoChange = this.handleGrupoFisicoChange.bind(this);
    this.handleControladorChange = this.handleControladorChange.bind(this);
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleNumeroChange = this.handleNumeroChange.bind(this);
    this.handleTituloChange = this.handleTituloChange.bind(this);
    this.renderFiltros = this.renderFiltros.bind(this);
  }

  componentDidMount() {
    this.resetarFiltros();
  }

  resetarFiltros() {
    this.setState({
      filtroGrupoFisico: FILTRO_TODOS,
      filtroControlador: FILTRO_TODOS,
      filtroStatus: FILTRO_TODOS,
      filtroNumero: FILTRO_TODOS,
      filtroTitulo: '',
    });
    this.props.setPaginaAtual(0);
  }

  handleGrupoFisicoChange(event) {
    const filtroGrupoFisico = event.target.value;
    this.setState({
      filtroGrupoFisico,
      filtroControlador: FILTRO_TODOS,
      filtroNumero: FILTRO_TODOS,
    });
    this.props.setPaginaAtual(0);
  }

  handleControladorChange(event) {
    this.setState({ filtroControlador: event.target.value, filtroNumero: FILTRO_TODOS });
    this.props.setPaginaAtual(0);
  }

  handleStatusChange(event) {
    this.setState({ filtroStatus: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handleNumeroChange(event) {
    this.setState({ filtroNumero: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handleTituloChange(event) {
    this.setState({ filtroTitulo: event.target.value });
    this.props.setPaginaAtual(0);
  }

  handlePageChange = page => {
    this.props.setPaginaAtual(page);
  };

  removerOs(data) {
    this.setState({ excluirOs: data });
  }

  confirmarExclusaoOs() {
    const { excluirOs } = this.state;
    if (!excluirOs) return;
    this.props.remove(excluirOs);
    this.setState({ excluirOs: null });
  }

  cancelarExclusaoOs() {
    this.setState({ excluirOs: null });
  }

  handleIniciarOs(os) {
    this.props.iniciarOs(os);
  }

  handleFinalizarOs(os) {
    this.props.finalizarOs(os);
  }

  renderStatusOs(os) {
    const slaTexto = formatSlaRestante(os);

    return (
      <div className="os-status-cell">
        {badge(STATUS_LABELS[os.status] || os.status, STATUS_BADGE_CLASS[os.status])}
        {temSlaAtivo(os) && slaTexto ? (
          <span className={`os-sla-tempo ${isSlaVencido(os) ? 'is-vencido' : ''}`}>{slaTexto}</span>
        ) : null}
      </div>
    );
  }

  renderFluxoAcao(os) {
    if (podeIniciarOs(os)) {
      return (
        <PermissaoUsuario tela="CadOrdemServico" campo="alterar" condicao={true}>
          <SPButton
            type="button"
            className="success btn-sm"
            icon="play"
            data-title="Iniciar OS"
            onClick={() => this.handleIniciarOs(os)}
          />
        </PermissaoUsuario>
      );
    }
    if (podeFinalizarOs(os)) {
      return (
        <PermissaoUsuario tela="CadOrdemServico" campo="finalizar" condicao={true}>
          <SPButton
            type="button"
            className="warning btn-sm"
            icon="check-circle"
            data-title="Finalizar OS"
            onClick={() => this.handleFinalizarOs(os)}
          />
        </PermissaoUsuario>
      );
    }
    return null;
  }

  renderFiltros(ordens) {
    const { filtroGrupoFisico, filtroControlador, filtroStatus, filtroNumero, filtroTitulo } = this.state;
    const opcoes = this.props.opcoes || { grupos_fisicos: [], controladores: [] };
    const grupos = opcoes.grupos_fisicos || [];
    const controladores = opcoes.controladores || [];

    const controladoresFiltrados = filtroGrupoFisico
      ? controladores.filter(c => String(c.grupo_fisico_id) === String(filtroGrupoFisico))
      : controladores;
    const numerosDisponiveis = obterNumerosDisponiveis(ordens, filtroGrupoFisico, filtroControlador);

    return (
      <div className="os-list-filters-bar">
        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="os-list-filtro-grupo">
            Grupo Físico
          </label>
          <select
            id="os-list-filtro-grupo"
            className="form-control os-list-filter-select"
            value={filtroGrupoFisico}
            onChange={this.handleGrupoFisicoChange}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            {grupos.map(g => (
              <option key={g.id} value={g.id}>
                {g.descricao}
              </option>
            ))}
          </select>
        </div>

        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="os-list-filtro-controlador">
            Controlador
          </label>
          <select
            id="os-list-filtro-controlador"
            className="form-control os-list-filter-select os-list-filter-select-ctrl"
            value={filtroControlador}
            onChange={this.handleControladorChange}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            {controladoresFiltrados.map(c => (
              <option key={c.id} value={c.id}>
                {`Ctrl ${String(c.numero_controlador).padStart(2, '0')}${c.endereco ? ` — ${c.endereco}` : ''}`}
              </option>
            ))}
          </select>
        </div>

        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="os-list-filtro-numero">
            Número
          </label>
          <select
            id="os-list-filtro-numero"
            className="form-control os-list-filter-select os-list-filter-select-numero"
            value={filtroNumero}
            onChange={this.handleNumeroChange}
            disabled={numerosDisponiveis.length === 0}
          >
            <option value={FILTRO_TODOS}>
              {numerosDisponiveis.length === 0 ? 'Nenhuma OS' : 'Todas'}
            </option>
            {numerosDisponiveis.map(numero => (
              <option key={numero} value={numero}>
                {numero}
              </option>
            ))}
          </select>
        </div>

        <div className="os-list-filter-group">
          <label className="os-list-filter-label" htmlFor="os-list-filtro-status">
            Status
          </label>
          <select
            id="os-list-filtro-status"
            className="form-control os-list-filter-select"
            value={filtroStatus}
            onChange={this.handleStatusChange}
          >
            <option value={FILTRO_TODOS}>Todos</option>
            {Object.keys(STATUS_LABELS).map(key => (
              <option key={key} value={key}>
                {STATUS_LABELS[key]}
              </option>
            ))}
          </select>
        </div>

        <div className="os-list-filter-group os-list-filter-group--search">
          <label className="os-list-filter-label" htmlFor="os-list-filtro-titulo">
            Título
          </label>
          <input
            id="os-list-filtro-titulo"
            type="search"
            className="form-control os-list-filter-input"
            value={filtroTitulo}
            onChange={this.handleTituloChange}
            placeholder="Pesquisar título..."
          />
        </div>
      </div>
    );
  }

  render() {
    const ordens = this.props.list || [];
    const ordensFiltradas = filtrarOrdens(ordens, this.state);

    const columns = [
      {
        Header: 'Ações',
        Cell: row => (
          <div className="os-actions-cell">
            <div className="os-actions-group">
              {this.renderFluxoAcao(row.original)}
              <PermissaoUsuario tela="CadOrdemServico" campo="interacoes" condicao={true}>
                <SPButton
                  type="button"
                  className="default btn-sm"
                  icon="comments"
                  data-title="Interações"
                  onClick={() => this.props.showInteracoes(row.original)}
                />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="materiais" condicao={true}>
                <SPButton
                  type="button"
                  className="info btn-sm"
                  icon="boxes"
                  data-title="Materiais"
                  onClick={() => this.props.showMateriais(row.original)}
                />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="alterar" condicao={true}>
                <SPButton
                  type="button"
                  className="warning btn-sm"
                  icon="pencil-alt"
                  data-title="Alterar"
                  onClick={() => this.props.showUpdate(row.original)}
                />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="excluir" condicao={true}>
                <SPButton
                  type="button"
                  className="danger btn-sm"
                  icon="trash-alt"
                  data-title="Excluir"
                  onClick={() => this.removerOs(row.original)}
                />
              </PermissaoUsuario>
            </div>
          </div>
        ),
        className: 'column_icon',
        width: 164,
        resizable: false,
        sortable: false,
        filterable: false,
      },
      {
        Header: 'Número',
        accessor: 'numero',
        width: 128,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-numero">{row.value}</span>,
      },
      {
        Header: 'Título',
        accessor: 'titulo',
        minWidth: 140,
        className: 'column_grid column_left os-col-titulo',
        filterable: false,
        Cell: row => celulaTitulo(row.original),
      },
      {
        Header: 'Tipo',
        accessor: 'tipo',
        width: 96,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => TIPO_LABELS[row.value] || row.value,
      },
      {
        Header: 'Prior.',
        accessor: 'prioridade',
        width: 82,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => badge(row.value, PRIORIDADE_BADGE_CLASS[row.value]),
      },
      {
        Header: 'Status',
        accessor: 'status',
        width: 128,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => this.renderStatusOs(row.original),
      },
      {
        Header: 'Atribuição',
        accessor: 'equipe_nome',
        width: 110,
        className: 'column_grid column_center os-col-hide-sm',
        filterable: false,
        Cell: row => celulaAtribuicao(row),
      },
      {
        Header: 'Abertura',
        accessor: 'data_abertura',
        width: 96,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => <span className="os-cell-data">{formatarHora(row.value)}</span>,
      },
      {
        Header: 'Interação',
        accessor: 'ultima_interacao_data',
        width: 96,
        className: 'column_grid column_center',
        filterable: false,
        Cell: row => celulaInteracao(row),
      },
    ];

    return (
      <div className="ordem-servico-premium-list table-container">
        <div className="os-list-top-panel">
          <p className="os-list-summary">{`${ordensFiltradas.length} ordem(ns) de serviço`}</p>
          {this.renderFiltros(ordens)}
        </div>
        <PremiumTableShell summary="" hideToolbar tableMinWidth={0}>
          <ReactTableGT2A
            data={ordensFiltradas}
            columns={columns}
            className="-striped -highlight"
            defaultPageSize={15}
            showPagination
            filterable={false}
            onPageChange={this.handlePageChange}
            page={this.props.paginaAtual}
            minRows={0}
          />
        </PremiumTableShell>

        <ActionConfirmModal
          show={!!this.state.excluirOs}
          title="Deseja realmente excluir?"
          message="A ordem de serviço e todos os registros vinculados serão removidos permanentemente."
          itemName={
            this.state.excluirOs
              ? `${this.state.excluirOs.numero}${this.state.excluirOs.titulo ? ` — ${this.state.excluirOs.titulo}` : ''}`
              : ''
          }
          confirmLabel="Excluir"
          destructive
          icon="trash-alt"
          onConfirm={this.confirmarExclusaoOs}
          onCancel={this.cancelarExclusaoOs}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  list: state.manutencaoOS.list,
  paginaAtual: state.manutencaoOS.paginaAtual,
  opcoes: state.manutencaoOS.opcoes,
});
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { showUpdate, showMateriais, showInteracoes, remove, setPaginaAtual, iniciarOs, finalizarOs },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(OrdemServicoList);
